import { Station } from '@vueling-ng/vy-cdk-searcher/lib/state/services/station/proxies';

export interface LocationDetails {
  cityCode: string;
  coordinates: Coordinates;
  countryCode: string;
  customsRequiredForCrew: boolean;
  provinceStateCode: string;
  subZoneCode: string;
  thirdPartyControlled: boolean;
  timeZoneCode: string;
  weightType: string;
  zoneCode: string;
  shortName: string;
  stationCode: string;
}

export interface StationMacs {
  code: string;
  name: string;
  longCode: string;
  countryName: string;
  countryCode: string;
  connection: string;
}

interface Coordinates {
  latitude: number;
  longitude: number;
}

export const genericStation: Station = {
  allowed: true,
  class: 'A',
  cultureCode: '',
  currencyCode: 'EUR',
  fullName: '',
  icaoCode: '',
  locationDetails: {
    cityCode: true,
    coordinates: { latitude: 0, longitude: 0 },
    countryCode: '',
    customsRequiredForCrew: false,
    subZoneCode: '210',
    timeZoneCode: '',
    weightType: 'Kilograms',
    zoneCode: '21',
    shortName: '',
    stationCode: '',
    provincesStateCode: '',
    thirdPartyController: false
  },
  shortName: '',
  stationCode: '',
  conversionCurrencyCode: undefined,
  macCode: ''
};
